var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppSelect',_vm._g(_vm._b({attrs:{"label":_vm.label,"hide-details":"","items":_vm.officeItems},model:{value:(_vm.Value),callback:function ($$v) {_vm.Value=$$v},expression:"Value"}},'AppSelect',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }